<template>
  <table>
    <colgroup>
      <col>
      <col span="2">
      <col>
      <col>
      <col>
      <col>
    </colgroup>
    <thead>
      <tr>
        <th rowspan="2">
          特徵 / 等級
        </th>
        <th rowspan="2">
          花朵受傷
        </th>
        <th rowspan="2">
          花朵凋萎（黃化）
        </th>
        <th rowspan="2">
          花苞黃化（消蕾）
        </th>
        <th rowspan="2">
          掉花（苞）
        </th>
        <th rowspan="2">
          花梗折斷
        </th>
        <th rowspan="2">
          葉片受傷
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td> A 級 </td>
        <td> 無 </td>
        <td> 無 </td>
        <td> 無 </td>
        <td> 無 </td>
        <td> 無 </td>
        <td> 無 </td>
      </tr>
      <tr>
        <td> B 級 </td>
        <td colspan="6">
          有 1 項特徵
        </td>
      </tr>
      <tr>
        <td> C 級 </td>
        <td colspan="6">
          有 2 項或以上特徵
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  export default {
    name: 'BaseTable',
  };
</script>

<style lang="scss" scoped>
  table {
    width: 100%;
    min-width: 1000px;

    col {
      width: 9%;
    }

    tr {
      &:hover {
        background: #e0ece420;
      }
    }

    th {
      text-align: center;
      color: #393b44;
      background-color: #e0ece4;
      font-weight: normal;
      padding: 0.5em 0.5rem;
    }

    td {
      color: #393b44;
      border: 1px solid #e0ece4;
      font-weight: light;
      padding: 1em 0.5rem;
      text-align: center;
    }
  }
</style>
